/**
 * Filter out study/project nodes from lineage data and clean parent references.
 * @param {Object} data - Raw lineage node map keyed by UUID
 * @returns {Object} Filtered node map
 */
export function filterLineageModels(data) {
  const filteredModels = ['study', 'project']
  const nodes = Object.values(data).filter(
    ({ model_name, deleted }) =>
      !filteredModels.includes(model_name) && !deleted,
  )
  const nodeIds = new Set()
  nodes.forEach((node) => nodeIds.add(node.id))

  nodes.forEach((node) => {
    node.parents = node.parents.filter((parentId) => nodeIds.has(parentId))
  })

  return nodes.reduce((acc, node) => {
    acc[node.id] = node
    return acc
  }, {})
}
